// export const dynamic = 'force-dynamic'
import React from 'react'
import BannerSlide from './BannerSlide'
import urls from '@/utils/urls/urls'
import cl from '@/utils/console/cl'

const Banner = async () => {
    const res = await fetch(urls?.banner, {
        cache: "no-cache"
    })
    const data = await res.json()
    const bannerData = Array.isArray(data?.data) ? data?.data : []
    // cl("bannerData", bannerData)
    // console.log("bannerData", bannerData)
    return (
        <>
            <BannerSlide data={bannerData} />
        </>
    )
}

export default Banner
